function onVideo() {
  $('.video .icon-play').on('click', function (e) {
    e.preventDefault();

    const videoContent = $(this).closest('.card').find('.video__content');
    const videoCover = $(this).closest('.card').find('.video__cover');

    videoCover.hide();
    videoContent.fadeIn(1000);
    videoContent.get(0).play();
  });
}

export default onVideo;
